/** i18n keys for Fast Rack mounting UI (English values in spa/app/src/i18n/template.json). */
export const MOUNT_FR = {
  anchorType: 'mount_fastrack_anchor_type',
  anchorTalonXe: 'mount_fastrack_anchor_talon_xe',
  anchorRtMini: 'mount_fastrack_anchor_rt_mini',
  anchorS5Clamps: 'mount_fastrack_anchor_s5_clamps',
  anchorPmBracket: 'mount_fastrack_anchor_pm_bracket',
  anchorEjot: 'mount_fastrack_anchor_ejot',
  anchorS5RibBracket: 'mount_fastrack_anchor_s5_ribbracket',
  rtMiniSpan: 'mount_fastrack_rt_mini_span',
  seamSpacing: 'mount_fastrack_seam_spacing',
  majorRibSpacing: 'mount_fastrack_major_rib_spacing',
  mountType: 'mount_fastrack_mount_type',
  sheathing: 'mount_fastrack_sheathing',
  truss: 'mount_fastrack_truss',
  terrain: 'mount_fastrack_terrain',
  terrainRough: 'mount_fastrack_terrain_rough',
  terrainOpen: 'mount_fastrack_terrain_open',
  terrainTooltip: 'mount_fastrack_terrain_tooltip',
  hiddenEndClamps: 'mount_fastrack_hidden_end_clamps',
  includeEndCaps: 'mount_fastrack_include_end_caps',
  clampStyle: 'mount_fastrack_clamp_style',
  clampClickLock: 'mount_fastrack_clamp_click_lock',
  clampTBolt: 'mount_fastrack_clamp_t_bolt',
  clampColour: 'mount_fastrack_clamp_colour',
  pestProtection: 'mount_fastrack_pest_protection',
  pestEdgeTrim: 'mount_fastrack_pest_edge_trim',
  pestCritterGuard: 'mount_fastrack_pest_critter_guard',
  fenceHeight: 'mount_fastrack_fence_height',
  fenceHeight6: 'mount_fastrack_fence_height_6',
  fenceHeight8: 'mount_fastrack_fence_height_8',
  fenceAttachmentType: 'mount_fastrack_fence_attachment_type',
  fenceJhooksCgClips: 'mount_fastrack_fence_jhooks_cg_clips',
  fenceJhooksEdgeClamps: 'mount_fastrack_fence_jhooks_edge_clamps',
  fenceEdgeClamps: 'mount_fastrack_fence_edge_clamps',
  spareParts: 'mount_fastrack_spare_parts',
  spare10: 'mount_fastrack_spare_10',
  spare5: 'mount_fastrack_spare_5',
  groundSnowSs: 'mount_fastrack_ground_snow_ss',
  rainOnSnowSr: 'mount_fastrack_rain_on_snow_sr',
  windPressure: 'mount_fastrack_wind_pressure',
  cableClips: 'mount_fastrack_cable_clips',
  preferredRailLengths: 'mount_fastrack_preferred_rail_lengths',
  preferredRailsTooltip: 'mount_fastrack_preferred_rails_tooltip',
  rail94: 'mount_fastrack_rail_94',
  rail139: 'mount_fastrack_rail_139',
  rail185: 'mount_fastrack_rail_185',
  calculatedSpan: 'mount_fastrack_calculated_span',
  snowLoadPerGrid: 'mount_fastrack_snow_load_per_grid',
  gridNumberSlope: 'mount_fastrack_grid_number_slope',
  gridNameSlope: 'mount_fastrack_grid_name_slope',
  pressureKpa: 'mount_fastrack_pressure_kpa',
  preferredRailsEmptyWarning: 'mount_fastrack_preferred_rails_empty_warning',
  hiddenClampLandscapeInfo: 'mount_fastrack_hidden_clamp_landscape_info',
  snowExceedsWarning: 'mount_fastrack_snow_exceeds_warning',
  rtMiniSpanUserLower: 'mount_fastrack_rt_mini_span_user_lower',
  rtMiniSpanCalcLower: 'mount_fastrack_rt_mini_span_calc_lower',
  tboltClampDepthError: 'mount_fastrack_tbolt_clamp_depth_error',
  tboltEndClampDepthError: 'mount_fastrack_tbolt_end_clamp_depth_error',
  clickLockMidDepthError: 'mount_fastrack_click_lock_mid_depth_error',
  clickLockStopperDepthError: 'mount_fastrack_click_lock_stopper_depth_error',
} as const
